import type { FeatureDefinition } from './features';

export default [
  {
    name: 'viewDepotLandingPage',
    isMainView: true,
    isRootLevel: true,
    route: 'depotLanding',
    action: 'r:depot-landing-page'
  },
  {
    name: 'viewLiveStatus',
    action: 'r:tour',
    isMainView: true,
    isRootLevel: true,
    route: 'liveStatus'
  },
  {
    name: 'liveStatusMapEnabled',
    action: 'r:live-status-map',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailView',
    action: 'r:tour-details',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailViewDevice',
    action: 'r:tour-device',
    needs: 'r:tour-details'
  },
  {
    name: 'viewUsageAnalysis',
    action: 'r:tour-activity',
    isMainView: true,
    isRootLevel: true,
    route: 'dailyActivities'
  },
  {
    name: 'viewUsageAnalysisFull',
    action: 'r:tour-activity-full',
    needs: 'r:tour-activity'
  },
  {
    name: 'tourDrivenHistory',
    action: 'r:tour-location-history',
    needs: 'r:tour-activity'
  },
  {
    name: 'readTourActivity',
    action: 'r:rtt',
    needs: 'r:tour-activity'
  },
  {
    name: 'viewTourRecommendations',
    action: 'r:tour-activity-recommendations',
    needs: 'r:rtt'
  },
  {
    name: 'readHealthStatus',
    action: 'r:health-status',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'readSmartInsights',
    action: 'r:smart-insights',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'viewTourPerformance',
    action: 'r:tour-perf',
    isMainView: true,
    isRootLevel: true,
    route: 'tourPerformance'
  },
  {
    name: 'viewDrivers',
    action: 'r:driver',
    isMainView: true,
    isRootLevel: true,
    route: 'appAccounts'
  },
  {
    name: 'createDriver',
    action: 'c:driver',
    needs: 'r:driver'
  },
  {
    name: 'updateDriver',
    action: 'u:driver',
    needs: 'r:driver'
  },
  {
    name: 'createDriver',
    action: 'c:driver',
    needs: 'r:driver'
  },
  {
    name: 'deleteDriver',
    action: 'd:driver',
    needs: 'r:driver'
  },
  {
    name: 'readBetterPlanner',
    action: 'r:better-planner',
    isMainView: false,
    isRootLevel: true
  }
] as const satisfies readonly FeatureDefinition[];
